/* eslint-disable react/prop-types */
import { Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line max-len
import { type StandardApplicationEntrypointSpecsFragment } from '../../../../../api/fragments/StandardApplicationEntrypointSpecs';
import {
    CreateStandardApplicationEntrypointDocument,
    type CreateStandardApplicationEntrypointMutation,
    type CreateStandardApplicationEntrypointMutationVariables,
} from '../../../../../api/mutations/createStandardApplicationEntrypoint';
import {
    UpdateStandardApplicationEntrypointDocument,
    type UpdateStandardApplicationEntrypointMutation,
    type UpdateStandardApplicationEntrypointMutationVariables,
} from '../../../../../api/mutations/updateStandardApplicationEntrypoint';
import { type StandardApplicationEntrypointSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import { type EndpointImplementation } from './types';

const implementation: EndpointImplementation<
    StandardApplicationEntrypointSpecsFragment,
    StandardApplicationEntrypointSettings & { applicationModuleId?: string }
> = {
    getTitle: t => t('routerDetails:endpoints.StandardApplicationEntrypoint.title'),
    ViewPanelComponent: ({ endpoint }) => (
        <Descriptions size="small" bordered>
            <Descriptions.Item label="Module">{endpoint.applicationModule.displayName}</Descriptions.Item>
            <Descriptions.Item label="Display Name">{endpoint.displayName}</Descriptions.Item>
        </Descriptions>
    ),
    getIsPrivate: () => true,
    FormComponent: () => {
        const { t } = useTranslation(['routerDetails']);

        return (
            <>
                <InputField
                    {...t('routerDetails:endpoints.fields.pathname', { returnObjects: true })}
                    name="pathname"
                />
                <InputField
                    {...t('routerDetails:endpoints.fields.displayName', { returnObjects: true })}
                    name="displayName"
                />
            </>
        );
    },
    getFormInitialValues: endpoint => ({
        pathname: endpoint.pathname,
        displayName: endpoint.displayName,
    }),
    submitCreation: (apolloClient, routerId, { applicationModuleId, ...values }) => {
        if (!applicationModuleId) {
            throw new Error('applicationModuleId is required');
        }

        return apolloClient.mutate<
            CreateStandardApplicationEntrypointMutation,
            CreateStandardApplicationEntrypointMutationVariables
        >({
            mutation: CreateStandardApplicationEntrypointDocument,
            variables: { routerId, applicationModuleId, settings: values },
        });
    },
    submitUpdate: (apolloClient, routerId, endpointId, values) =>
        apolloClient.mutate<
            UpdateStandardApplicationEntrypointMutation,
            UpdateStandardApplicationEntrypointMutationVariables
        >({
            mutation: UpdateStandardApplicationEntrypointDocument,
            variables: { routerId, endpointId, settings: values },
        }),
};

export default implementation;
